import { Grid, TextField } from "@mui/material";
import loginLogo from "assets/img/getOtpVector.svg";
import styled from "styled-components";
import { theme } from "styles/mui-config";

export const StyledContainer = styled(Grid)`
  max-width: 100% !important;
  margin: 0px !important;
  padding: 0px !important;
`;

export const StyledGrid = styled(Grid)`
  width: calc(50% - 120px);
  background: url(${loginLogo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  @media (max-width: 1199px) {
    width: calc(41.69% - 120px);
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
`;

export const StyledImg = styled.img`
  width: 100px !important;
`;

export const StyledTextField = styled(TextField)`
  background-color: #f2f6fc !important;
  border-radius: 10px !important;
  overflow: hidden !important;
  & .MuiFilledInput-root {
    background-color: #f2f6fc !important;
  }
  & .MuiFilledInput-root::before {
    border: none !important;
  }
  & input {
    color: #002b7a;
  }
  & label {
    color: #002b7a;
    font-size: 1rem;
  }
  & input:-webkit-autofill,
  & input:-webkit-autofill:hover,
  & input:-webkit-autofill:focus,
  & input:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s !important;
  }
  & .MuiInputAdornment-root svg {
    font-size: 24px;
    color: #b2bcd0;
  }
`;

export const BackBtn = styled.div`
  width: 100%;
  position: absolute;
  top: 60px;
  left: 0;
  & svg {
    font-size: 1.7rem;
    color: ${theme.palette.primary.main};
  }
  & button {
    width: max-content;
  }
  @media screen and (max-width: 900px) {
  }
`;
